import GavelOutlinedIcon from '@mui/icons-material/GavelOutlined';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { LawTaggedText } from '../law-tagged-text';
import { aiActUrl } from './ai-act-url';

/** Art. 50 Reg. UE 2024/1689: visibile al primo contatto, non affidato al solo colore. */
export function AiActDisclaimer() {
  const { t, i18n } = useTranslation('documents');
  return (
    <Box
      role="note"
      data-testid="ai-act-disclaimer"
      sx={{ display: 'flex', gap: 1, p: 1.5, borderRadius: 1, bgcolor: 'action.hover' }}
    >
      <GavelOutlinedIcon fontSize="small" aria-hidden sx={{ mt: 0.25, color: 'text.secondary' }} />
      <Box>
        <Typography variant="overline" sx={{ display: 'block', lineHeight: 1.4 }}>
          {t('deadlines.aiPreview.disclaimerEyebrow')}
        </Typography>
        <Typography variant="body2" sx={{ color: 'text.secondary' }}>
          <LawTaggedText
            text={t('deadlines.aiPreview.disclaimerBody')}
            href={aiActUrl(i18n.language)}
          />
        </Typography>
      </Box>
    </Box>
  );
}
